/*@ngInject*/
const UploadAttachmentCollaborationEmailRepository = function (baseRepository, attachmentUtil) {

    angular.extend(this, baseRepository);

    this.uploadAttachment = function (emailId, data, file) {
        let url = '/rest/Email/'+ emailId +'/uploadAttachment',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                },
                params:data
            };

        formData.append('file', file);

        return this.post(url, formData, config);
    };
};

angular.module('gw-um-submission')
    .service('uploadAttachmentCollaborationEmailRepository', UploadAttachmentCollaborationEmailRepository);
